
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.625 2.188h-6.25c-1.875 0-3.125.937-3.125 3.124v4.375c0 2.188 1.25 3.126 3.125 3.126h6.25c1.875 0 3.125-.938 3.125-3.126V5.314c0-2.188-1.25-3.125-3.125-3.125zm.294 3.806L8.962 7.556A2.336 2.336 0 017.5 8.05c-.525 0-1.056-.163-1.463-.494L4.082 5.994a.48.48 0 01-.075-.663.467.467 0 01.656-.075L6.62 6.82c.475.381 1.281.381 1.756 0l1.956-1.563c.2-.162.5-.131.657.075.162.2.13.5-.07.663z","fill":"#838883"}})])
          )
        }
      }
    